const constants = {
  passwordMinLength: 6,
  emailMaxLength: 128,
};

export default constants;
